import React from 'react';
import { useDisplayPredictions } from '../../contexts/predictions.hooks';
import { Toggler } from '../Toggler';

export function TogglePredictionsDisplayButton() {
  const [displayPredictions, setDisplayPredictions] = useDisplayPredictions();

  return (
    <Toggler checked={displayPredictions} onChange={setDisplayPredictions}>
      Display detections
    </Toggler>
  );
}
